import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  displayMode: "default",
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    initialDisplayModelLoaded(state, action){
      state.displayMode = action.payload.display_mode || "default";
    }
  }
});

export const {
  initialDisplayModelLoaded
} = commonSlice.actions;

export const commonReducer = commonSlice.reducer;